export const setCurrentActiveTab = (currentActiveTab: string) => {
  return {
    type: SET_CURRENT_ACTIVE_TAB,
    payload: currentActiveTab,
  };
};

export const setLatestStartDate = (
  latestFilterStartDate: Date | number | string
) => {
  return {
    type: SET_LATEST_START_DATE,
    payload: latestFilterStartDate,
  };
};

export const setLatestEndDate = (
  latestFilterEndDate: Date | number | string
) => {
  return {
    type: SET_LATEST_END_DATE,
    payload: latestFilterEndDate,
  };
};

export const setLatestTab = (latestTabValue: string) => {
  return {
    type: SET_LATEST_TAB,
    payload: latestTabValue,
  };
};

export const setLatestRadioValue = (latestRadioValue: string) => {
  return {
    type: SET_LATEST_RADIO_VALUE,
    payload: latestRadioValue,
  };
};

export const setLast12MonthsDocs = (docs: string) => {
  return {
    type: SET_LAST_12_MONTHS_DOCS,
    payload: docs,
  };
};

export const resetLettersReports = () => {
  return {
    type: RESET_LETTERS_REPORTS,
  };
};

export const SET_CURRENT_ACTIVE_TAB = "SET_CURRENT_ACTIVE_TAB";
export const SET_LATEST_START_DATE = "SET_LATEST_START_DATE";
export const SET_LATEST_END_DATE = "SET_LATEST_END_DATE";
export const SET_LATEST_TAB = "SET_LATEST_TAB";
export const SET_LATEST_RADIO_VALUE = "SET_LATEST_RADIO_VALUE";
export const RESET_LETTERS_REPORTS = "RESET_LETTERS_REPORTS";
export const SET_LAST_12_MONTHS_DOCS = "SET_LAST_12_MONTHS_DOCS";
